import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import ConfigProvider from '../../ConfigProvider';
import Icon from '../../Icon';
import Tooltip from '../../Tooltip';
import { TH_DECORATOR } from '../common';
export default function HeadDescription(_ref) {
  var mapColumns = _ref.mapColumns;
  return {
    columns: mapColumns(function (column) {
      var description = column.description;

      if (!description) {
        return null;
      }

      return _defineProperty({}, TH_DECORATOR, function (children) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(ConfigProvider, {
          size: "small"
        }, /*#__PURE__*/React.createElement(Tooltip, {
          arrowPointAtCenter: true,
          placement: "bottomLeft",
          theme: "dark",
          title: description
        }, /*#__PURE__*/React.createElement("div", {
          className: "jmtd-table-plugin-head-description"
        }, /*#__PURE__*/React.createElement(Icon, {
          className: "jmti-question-circle jmtd-table-plugin-head-description-icon"
        }), /*#__PURE__*/React.createElement("div", {
          className: "jmtd-table-head-placeholder"
        })))));
      });
    })
  };
}